export default __webpack_public_path__ + "static/media/ionic-ios-close-circle-outline.18f8ebad.svg";